module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-slot-disable"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Disable")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Disable vehicle slot")])]), _c('div', {
    staticClass: "row"
  }), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "large-6 text-left"
  }, [(!_vm.noreason) ? _c('label', [_vm._v("Reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('label', [_vm._v("Disable without reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noreason),
      expression: "noreason"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.noreason) ? _vm._i(_vm.noreason, null) > -1 : (_vm.noreason)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.noreason,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.noreason = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.noreason = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.noreason = $$c
        }
      }, _vm.toggleReason]
    }
  })])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "color-class": "success",
      "action": _vm.disable,
      "confirm": true
    },
    slot: "footer"
  }, [_vm._v("Disable")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9654e37e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/VehicleSlotDisableReveal.vue
// module id = 2642
// module chunks = 1